<template>
    <div class="col-sm-4" v-if="can('reports.*')">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">{{i18n("Reporting")}}</h1>
            </div>
            <div class="card-body">
                <ul class="list-unstyled grid-list">
<!--alx-->
                    <router-link to="/reports/online-sales" tag="li" v-if="can('reports.sales')">
                    <!--router-link to="/reports/online-sales" tag="li" v-if="can('superadmin.logs')"-->
                        <a href="#" title="">{{i18n("Online sales reporting")}}</a>
                    </router-link>
<!--alx-->
                    <router-link to="/reports/sales" tag="li" v-if="can('reports.sales')">
                        <a href="#" title="">{{i18n("Sales reporting")}}</a>
                    </router-link>
                    <router-link to="/reports/dispatcher" tag="li" v-if="can('reports.dispatcher')">
                        <a href="#" title="">{{i18n("Dispatch reporting")}}</a>
                    </router-link>
                    <router-link to="/transporter-reports" tag="li" v-if="can('reports.transporter')">
                        <a href="#" title="">{{i18n("Transporter reports")}}</a>
                    </router-link>
                    <router-link to="/reports/ministry" tag="li" v-if="can('reports.ministry')">
                        <a href="#" title="">{{i18n("Reports for Min. Trans.")}}</a>
                    </router-link>
                    <router-link to="/reports/validator" tag="li" v-if="can('reports.dispatcher')">
                        <a href="#" title="">{{i18n("Reports for Validator.")}}</a>
                    </router-link>
                    <router-link to="/reports/reversals" tag="li" v-if="can('reports.reversals')">
                        <a href="#" title="">{{i18n("Reversals")}}</a>
                    </router-link>
                    <router-link to="/reports/baggage" tag="li" v-if="can('reports.baggage')">
                        <a href="#" title="">{{i18n("Baggage")}}</a>
                    </router-link>
<!--alx-->
                    <router-link to="/citizenship-reports" tag="li" v-if="can('reports.citizenship')">
                        <a href="#" title="">{{i18n("Citizenship")}}</a>
                    </router-link>
<!--alx-->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ReportsCard"
    }
</script>

<style scoped>

</style>
